/**
 * @fileOverview This component is for all markets to load
 * market specific terms and conditions.
 */
import React from 'react';
import { useIntl } from 'react-intl';
import {
  sanitizeHtml, sanitizeLinkContent,
} from '@americanexpress/axp-manage-bookings-utils/build/utilities/helpers';
import { useFetchye } from 'fetchye';

import styles from './styles.scss';
import Spinner from '../Spinner/Spinner';
import { isLinkContent } from '../../helpers/helpers';

export const TNCReader = () => {
  const intl = useIntl();
  const { isLoading, data } = useFetchye(intl?.messages?.links?.termsLink);

  if (isLoading) {
    return <Spinner label="Intl Terms Progress Bar" />;
  }

  return (
    <div className={`card ${styles.tncFooter}`}>
      {
        data?.body?.tnc?.map((tncTerms) => (
          <div className="container" key={tncTerms?.header}>
            {tncTerms?.header && (
              <h3 className="margin-1-b heading-2">
                {tncTerms?.header}
              </h3>
            )}
            {tncTerms?.texts?.map((text) => (
              isLinkContent(intl.locale)
                ? (
                  <p className="margin-1-tb label-3" key={text}>
                    {sanitizeLinkContent(text)}
                  </p>
                )
                : (
                  <p className="margin-1-tb" key={text}>
                    {sanitizeHtml(text)}
                  </p>
                )
            ))}
          </div>
        ))
      }
    </div>
  );
};

export default TNCReader;
